"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TimelineItem_1 = __importDefault(require("@mui/lab/TimelineItem"));
var TimelineOppositeContent_1 = __importDefault(require("@mui/lab/TimelineOppositeContent"));
var TimelineSeparator_1 = __importDefault(require("@mui/lab/TimelineSeparator"));
var prism_icons_1 = require("@octanner/prism-icons");
var React = __importStar(require("react"));
var Box_1 = __importDefault(require("../Box"));
var colors_1 = require("../ThemeProvider/colors");
var Tooltip_1 = __importDefault(require("../Tooltip"));
var Typography_1 = __importDefault(require("../Typography"));
var styles_1 = require("./styles");
var Timeline = function (_a) {
    var events = _a.events, _b = _a.variant, variant = _b === void 0 ? 'simple' : _b, _c = _a.position, position = _c === void 0 ? 'right' : _c, sx = _a.sx;
    var isComplex = variant === 'complex';
    return (React.createElement(styles_1.StyledTimeline, { sx: sx, position: position, "data-testid": "timeline" }, events.map(function (_a, i) {
        var title = _a.title, timeFrame = _a.timeFrame, timeFrameUnit = _a.timeFrameUnit, dotVariant = _a.dotVariant, timelineItemFooter = _a.timelineItemFooter, button = _a.button, tags = _a.tags, description = _a.description, customFooter = _a.customFooter, _b = _a.shouldHaveBorderBottom, shouldHaveBorderBottom = _b === void 0 ? true : _b;
        return (React.createElement(React.Fragment, null,
            React.createElement(styles_1.EventContainer, { "data-testid": "event-container", key: title },
                React.createElement(TimelineItem_1.default, null,
                    isComplex && (timeFrame || timeFrameUnit) && (React.createElement(TimelineOppositeContent_1.default, { "data-testid": "timeline-opposite-content" },
                        React.createElement(Typography_1.default, null,
                            timeFrame,
                            " ",
                            timeFrameUnit))),
                    React.createElement(TimelineSeparator_1.default, null,
                        React.createElement(styles_1.StyledTimelineDot, { variant: dotVariant !== null && dotVariant !== void 0 ? dotVariant : 'filled' }),
                        isComplex ? (React.createElement(styles_1.StyledTimelineConnector, null)) : (i !== events.length - 1 && React.createElement(styles_1.StyledTimelineConnector, null))),
                    React.createElement(styles_1.StyledTimelineContent, { "data-testid": "timeline-content" },
                        React.createElement(styles_1.TimelineContentContainer, { shouldHaveBorderBottom: shouldHaveBorderBottom, variant: variant },
                            isComplex && position === 'left' && button && (React.createElement(Box_1.default, { "data-testid": "left-button" }, button())),
                            React.createElement(Box_1.default, null,
                                React.createElement(Typography_1.default, { variant: "body1", fontWeight: isComplex ? 800 : 500 }, title),
                                isComplex && tags && (React.createElement(styles_1.TagContainer, { "data-testid": "tag-container", position: position }, tags.map(function (tag, i) { return (React.createElement(styles_1.StyledTag, { key: title + tag.title, variant: "archived", "data-testid": "tag:".concat(tag.title) },
                                    tag.title,
                                    tag.infoText && (React.createElement(Tooltip_1.default, { title: tag.infoText, placement: "top" },
                                        React.createElement(prism_icons_1.InformationCircle, { sx: { color: colors_1.tannerGray[400] } }))))); }))),
                                isComplex && description && (React.createElement(Typography_1.default, { variant: "body1", "data-testid": "timeline-item-description-text" }, description))),
                            isComplex && position === 'right' && button && (React.createElement(Box_1.default, { "data-testid": "right-button" }, button()))),
                        isComplex && timelineItemFooter && (React.createElement(Box_1.default, { "data-testid": "timeline-item-footer-content" }, timelineItemFooter()))))),
            isComplex && customFooter && (React.createElement(styles_1.CustomFooter, null, customFooter()))));
    })));
};
exports.default = Timeline;
//# sourceMappingURL=index.js.map